import { Space, TableProps } from "antd";
import { Link } from "react-router-dom";
import {
  PaymentStatus,
  PaymentStatusLabel,
  ShippingStatus,
  ShippingStatusLabel,
} from "../../../enum/lisence";
import { DataType } from "../../../models/interface/license.interface";

export const Columns: TableProps<DataType>["columns"] = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 50,
    render: (id) => (
      <p className="mb-0 overflow-hidden text-ellipsis max-w-[50px] whitespace-nowrap">
        {id}
      </p>
    ),
  },
  {
    title: "HW Signature",
    dataIndex: "hardwareSignature",
    key: "hardwareSignature",
    width: 138,
    render: (hardwareSignature) => (
      <p className="mb-0 overflow-hidden text-ellipsis max-w-[138px] whitespace-nowrap">
        {hardwareSignature}
      </p>
    ),
  },
  {
    title: "カメラシリアルナンバー",
    dataIndex: "cameraSerial",
    key: "cameraSerial",
    width: 192,
  },
  {
    title: "HWシリアルナンバー",
    dataIndex: "assignedDeviceSerial",
    key: "assignedDeviceSerial",
    width: 180,
  },
  {
    title: "有効期限",
    dataIndex: "expiresAt",
    key: "expiresAt",
    render: (_, { expiresAt }) => <span>{expiresAt?.split("T")[0]}</span>,
    width: 122,
  },
  {
    title: "Agent Name",
    dataIndex: "assignedAgent",
    key: "assignedAgent",
    width: 108,
    render: (assignedAgent) => (
      <p className="mb-0 overflow-hidden text-ellipsis max-w-[108px] whitespace-nowrap">
        {assignedAgent}
      </p>
    ),
  },
  {
    title: "申請日",
    dataIndex: "requestedAt",
    key: "requestedAt",
    render: (_, { requestedAt }) => <span>{requestedAt?.split("T")[0]}</span>,
    width: 120,
  },
  {
    title: "ライセンス購入状態",
    dataIndex: "status",
    key: "status",
    render: (_, { batch }) => {
      if (batch.paymentStatus === PaymentStatus.PAID) {
        return (
          <div className="rounded-md w-[86px] h-[26px] bg-[#77BF4033] text-center">
            <p className="text-sm font-normal text-[#098906] mb-0 leading-[26px]">
              支払い済み
            </p>
          </div>
        );
      }
      if (batch.paymentStatus === PaymentStatus.UNPAID) {
        return (
          <div className="rounded-md w-[94px] h-[26px] bg-[#FFA90933] text-center">
            <p className="text-sm font-normal text-[#FF8B01] mb-0 leading-[26px]">
              未払い
            </p>
          </div>
        );
      }
      return (
        <div className="rounded-md w-[86px] h-[26px] bg-[#FF978B33] text-center">
          <p className="text-sm font-normal text-[#FF5646] mb-0 leading-[26px]">
            キャンセル
          </p>
        </div>
      );
    },
    width: 160,
  },
  {
    title: "アクション",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        <Link
          to={`/admin/license-management/${record.id}`}
          className="base-button w-[75px] h-[41px] rounded  flex justify-center items-center"
        >
          詳細
        </Link>
      </Space>
    ),
    width: 104,
  },
];

export const ColumnsExtend: TableProps<DataType>["columns"] = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 50,
    render: (id) => (
      <p className="mb-0 overflow-hidden text-ellipsis max-w-[50px] whitespace-nowrap">
        {id}
      </p>
    ),
  },
  {
    title: "HW Signature",
    dataIndex: "hardwareSignature",
    key: "hardwareSignature",
    width: 138,
    render: (hardwareSignature) => (
      <p className="mb-0 overflow-hidden text-ellipsis max-w-[138px] whitespace-nowrap">
        {hardwareSignature}
      </p>
    ),
  },
  {
    title: "DICOM serial number",
    dataIndex: "hardwareSignature",
    key: "hardwareSignature",
    width: 174,
    render: (hardwareSignature) => (
      <p className="mb-0 overflow-hidden text-ellipsis max-w-[174px] whitespace-nowrap">
        {hardwareSignature}
      </p>
    ),
  },
  {
    title: "カメラシリアルナンバー",
    dataIndex: "cameraSerial",
    key: "cameraSerial",
    width: 192,
  },
  {
    title: "HWシリアルナンバー",
    dataIndex: "assignedDeviceSerial",
    key: "assignedDeviceSerial",
    width: 180,
  },
  {
    title: "有効期限",
    dataIndex: "expiresAt",
    key: "expiresAt",
    render: (_, { expiresAt }) => <span>{expiresAt?.split("T")[0]}</span>,
    width: 122,
  },
  {
    title: "Agent Name",
    dataIndex: "assignedAgent",
    key: "assignedAgent",
    width: 108,
    render: (assignedAgent) => (
      <p className="mb-0 overflow-hidden text-ellipsis max-w-[108px] whitespace-nowrap">
        {assignedAgent}
      </p>
    ),
  },
  {
    title: "申請日",
    dataIndex: "requestedAt",
    key: "requestedAt",
    render: (_, { requestedAt }) => <span>{requestedAt?.split("T")[0]}</span>,
    width: 120,
  },
  {
    title: "ライセンス購入状態",
    dataIndex: "status",
    key: "status",
    render: (_, { batch }) => {
      if (batch.paymentStatus === PaymentStatus.PAID) {
        return (
          <div className="rounded-md w-[86px] h-[26px] bg-[#77BF4033] text-center">
            <p className="text-sm font-normal text-[#098906] mb-0 leading-[26px]">
              支払い済み
            </p>
          </div>
        );
      }
      if (batch.paymentStatus === PaymentStatus.UNPAID) {
        return (
          <div className="rounded-md w-[94px] h-[26px] bg-[#FFA90933] text-center">
            <p className="text-sm font-normal text-[#FF8B01] mb-0 leading-[26px]">
              {PaymentStatusLabel.unpaid}
            </p>
          </div>
        );
      }
    },
    width: 160,
  },
  {
    title: "出荷ができるか",
    dataIndex: "shipping",
    key: "shipping",
    render: (_, { batch }) => {
      if (batch.shippingStatus === ShippingStatus.NOT_SHIPPED) {
        return (
          <div className="rounded-md w-[94px] h-[26px] bg-[#FFA90933] text-center">
            <p className="text-sm font-normal text-[#FF8B01] mb-0 leading-[26px]">
              {ShippingStatusLabel.not_shipped}
            </p>
          </div>
        );
      }
      if (batch.shippingStatus === ShippingStatus.SHIPPED) {
        return (
          <div className="rounded-md w-[86px] h-[26px] bg-[#77BF4033] text-center">
            <p className="text-sm font-normal text-[#098906] mb-0 leading-[26px]">
              {ShippingStatusLabel.shipped}
            </p>
          </div>
        );
      }
    },
    width: 160,
  },
  {
    title: "アクション",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        <Link
          to={`/admin/license-management/${record.id}`}
          className="base-button w-[75px] h-[41px] rounded  flex justify-center items-center"
        >
          詳細
        </Link>
      </Space>
    ),
    width: 104,
  },
];
